import React from 'react';
import { compose } from 'ramda';
import { withApiCall } from '../stores/sanity.api';
import { withLoadingSpinner } from '../components/LoadingSpinner';
import { withErrorHandling } from '../components/Error';
import DemoPagesList from '../components/DemoPagesList';
import HtmlHead from '../components/HtmlHead';
import Header from '../components/Header';
import LandingText from '../components/LandingText';
import PrivacyPolicy from '../components/PrivacyPolicy';

const QUERY = `
  query {
    demoPages: allDemoPage(where: {featured: {eq: true}} sort: {_updatedAt: DESC}) {
      _id
      title
      featured
      description
      slug {
        current
      }
      videoSrc
      image {
        asset {
          url
        }
      }
    }
  }
`;

function LandingPage({ data }) {
  return (
    <>
      <HtmlHead title="Home" />
      <Header showBanner />
      <LandingText />
      <DemoPagesList demoPages={data.demoPages} />
      <PrivacyPolicy />
    </>
  );
}

export default compose(
  withApiCall(() => ({
    query: QUERY,
  })),
  withLoadingSpinner(),
  withErrorHandling()
)(LandingPage);
